<template>
  <thead>
    <tr>
      <th class="rbu-section-fluctuation-column-1"></th>
      <th class="rbu-section-fluctuation-column-2 text-right">#</th>
      <th class="rbu-section-fluctuation-column-value">Value</th>
      <th class="rbu-section-fluctuation-column-multiplier">Multiplier</th>
      <th class="rbu-section-fluctuation-column-formula">Formula</th>
      <th class="rbu-section-fluctuation-column-descriptions">Description</th>
      <th class="rbu-section-fluctuation-column-actions"></th>
    </tr>
  </thead>
</template>
<script>
export default {
  name: "RbuSectionFluctuationTableHeader",
};
</script>
